'use client'

import { useState } from 'react'
import Script from 'next/script'

const OpenPay = () => {
  const [openPayLoaded, setOpenPayLoaded] = useState(false)

  return (
    <>
      <Script
        src="https://openpay.s3.amazonaws.com/openpay.v1.min.js"
        strategy="afterInteractive"
        onLoad={() => {
          console.log('OpenPay core loaded')
          setOpenPayLoaded(true)
        }}
      />
      {openPayLoaded && (
        <Script
          src="https://openpay.s3.amazonaws.com/openpay-data.v1.min.js"
          strategy="afterInteractive"
          onLoad={() => console.log('OpenPay data loaded')}
        />
      )}
    </>
  )
}

export default OpenPay
